//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import common from "@/assets/js/Common.js";
import api from "@/assets/js/Api.js";

import inputbox from '@/components/ui/inputbox';

export default {
    components: {inputbox},
    data(){
        return {
            info: {
                lpn: '',
                phone: '',
                pwd: '',
                pwd2: '',
                code: '',
                referid: '',
            },
            sms: {
                timeOrigin: 60,
                time: 60,
                text: '获取验证码',
                disabled: false,
                handle: null,
            }
        }
    },
    methods:{

        // 登录
        submit(){

            const info = this.info;

            if(!common.isMobile(info.phone)){
                this.$vux.toast.text("请输入正确的手机号");
                return;
            }

            if(info.code.length < 4){
                this.$vux.toast.text("验证码不正确");
                return;
            }

            if(info.pwd.length < 1){
                this.$vux.toast.text("密码不能为空");
                return;
            }

            if(info.pwd != info.pwd2 ){
                this.$vux.toast.text("两次密码填写不一致");
                return;
            }

            const opts = {
                url: api.registerPwd,
                data: {
                    ...info,
                },
                type: 'post',
            }
            common.query(opts).then(res=>{
                common.storage("userInfo",JSON.stringify(res.data));
                const callback = common.storage("callback") || "/member";

                common.storage("callback",'');
                common.storage("referid",'');

                this.$router.push(callback);
            },res=>{
                this.$vux.toast.text(res.message)
            });

        },

        // 发送登录短信
        sendSms(){

            if(this.sms.disabled){
                return;
            }

            if(!common.isMobile(this.info.phone)){
                this.$vux.toast.text("输入手机号不正确");
                return;
            }

            this.sms.disabled = true;

            const opts = {
                url: api.registerSendSms,
                data: {
                    ...this.info
                },
                type: 'post'
            }

            common.query(opts).then(res=>{
                this.smsTimeout();
                this.$vux.toast.text("验证码发送成功，请在手机上查看");
            },res=>{
                this.$vue.toast.show(res.message);
                this.sms.disabled = false;
            })

        },

        // 验证码倒计时
        smsTimeout(){
            this.sms.time--;
            this.sms.text = this.sms.time + ' 秒后获取';

            clearTimeout(this.sms.handle);
            this.sms.handle = setTimeout(()=>{
                if(this.sms.time === 0){
                    this.sms.text = "获取验证码";
                    this.sms.time = this.sms.timeOrigin;
                    this.sms.disabled = false;
                }else{
                    this.smsTimeout();
                }
            },1000);
        }

    },
    mounted(){
        this.info.referid = common.storage("referid") || '';
        console.log('register');
    },
}




// WEBPACK FOOTER //
// ./src/views/login/register.vue